import Marquee from "react-fast-marquee";

const ITEMS = [
  "Software Development",
  "Brand Identity",
  "Graphic Design",
  "Product Design",
  "Web Experiences",
  "Motion & Interaction",
];

export const EditorialMarquee = () => (
  <section className="relative py-10 md:py-14 border-y border-[#242424] bg-[#0c0c0e]" data-testid="marquee-section">
    <Marquee speed={40} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <div key={i} className="flex items-center">
          <span className="stroke-text font-display text-5xl md:text-7xl tracking-tighter px-8">
            {t}
          </span>
          <span className="text-gold text-2xl md:text-3xl">✦</span>
        </div>
      ))}
    </Marquee>
  </section>
);
